module.exports = __webpack_public_path__ + "static/media/ghcf-logo.2f5d4814.png";